document.addEventListener('DOMContentLoaded', function () {
    var warenkorbShop = new Warenkorb('.shop');
    warenkorbShop.initShop();
    
    const shop = new Anzahl('.shop__buch-input-container', '.shop__buch-input-buttons--plus', '.shop__buch-input-buttons--minus', '.shop__buch-input');

    shop.initialisierungInputGroups();
});